import axiosInstance from "./AxiosConfig";

class CouponMasterApi {
  // ---------------- CREATE ----------------
  async CreateCoupon(data) {
    try {
      const response = await axiosInstance.post(
        "/couponMaster/create",
        data
      );
      return response.data;
    } catch (error) {
      console.error("CreateCoupon Error:", error);
      return null;
    }
  }

  // ---------------- GET ALL ----------------
  async GetAllCoupons(includeDeleted = false) {
    try {
      const response = await axiosInstance.get(
        `/couponMaster/get?includeDeleted=${includeDeleted}`
      );
      return response.data;
    } catch (error) {
      console.error("GetAllCoupons Error:", error);
      return null;
    }
  }

  // ---------------- GET BY ID ----------------
  async GetCouponById(id) {
    try {
      const response = await axiosInstance.get(
        `/couponMaster/get/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("GetCouponById Error:", error);
      return null;
    }
  }

  // ---------------- UPDATE ----------------
  async UpdateCoupon(id, data) {
    try {
      const response = await axiosInstance.put(
        `/couponMaster/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("UpdateCoupon Error:", error);
      return null;
    }
  }

  // ---------------- DELETE (soft) ----------------
  async DeleteCoupon(id, data = {}) {
    try {
      const response = await axiosInstance.delete(
        `/couponMaster/delete/${id}`,
        { data }
      );
      return response.data;
    } catch (error) {
      console.error("DeleteCoupon Error:", error);
      return null;
    }
  }
}

export default new CouponMasterApi();